import React, { useImperativeHandle, forwardRef } from 'react';

import { useMutation } from '@tanstack/react-query';

import FormContainer from '../../../../FormContainer';

import useDocumentForm from '../../../../../../forms/loan/document';
import UploadService from '../../../../../../services/UploadService';
import DocumentService from '../../../../../../services/DocumentService';
import { useUiContext } from '../../../../../../context/UiContext';

const createDocumentFromFile = (file) => {
  return {
    name: file?.name?.split?.('.pdf')[0],
    type: '',
    description: '',
  };
};

const DocumentForm = forwardRef(
  ({ file, deleteDocument, loanId, lenderId }, ref) => {
    const { showToast } = useUiContext();

    const { mutateAsync: createDocument } = useMutation({
      mutationFn: async (formValues) => {
        const uploadedFile = await UploadService.uploadAttachment(file);
        return DocumentService.createDocument({
          formValues: {
            description: formValues.description,
            status: 'accepted',
            date: formValues.date || new Date(),
            private_document: {
              ...uploadedFile,
              name: formValues.name,
              type: formValues.type,
            },
          },
          loanId,
          lenderId,
        });
      },
      onSuccess: () => {
        console.log('Document created successfully');
      },
      onError: (error) => {
        console.log(error);
        showToast({
          text: error?.response?.data?.message || 'Something went wrong',
          type: 'error',
        });
      },
    });

    const documentForm = useDocumentForm(
      createDocument,
      createDocumentFromFile(file)
    );

    useImperativeHandle(ref, () => ({
      formik: documentForm.formik,
    }));

    return (
      <div className="p-7 col-span-full sm:col-span-6 xl:col-span-4 bg-white dark:bg-slate-800 shadow-lg rounded-sm border border-slate-200 dark:border-slate-700 mb-10 relative">
        <button
          onClick={deleteDocument}
          type="button"
          className="absolute right-4 top-4 block rounded-full bg-slate-100 dark:bg-slate-700 text-slate-500 dark:text-slate-400 hover:text-slate-600 dark:hover:text-slate-300"
        >
          <span className="sr-only">Back</span>
          <svg width="32" height="32" viewBox="0 0 32 32">
            <path
              className="fill-current"
              d="M15.95 14.536l4.242-4.243a1 1 0 111.415 1.414l-4.243 4.243 4.243 4.242a1 1 0 11-1.415 1.415l-4.242-4.243-4.243 4.243a1 1 0 01-1.414-1.415l4.243-4.242-4.243-4.243a1 1 0 011.414-1.414l4.243 4.243z"
            />
          </svg>
        </button>
        <FormContainer
          form={documentForm}
          noSubmit
          gridStyle="grid gap-5 md:grid-cols-3 xl:grid-cols-3"
          noBillComId
        />
      </div>
    );
  }
);

export default DocumentForm;
